export const ACQUIRE_CARD_FLAG_TYPE = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
};
